// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"639":"9e018e96","937":"4d15e861","1008":"bb104495","8002":"8cca158e"}[chunkId] + ".chunk.css";
};